const leftPad = function(number, desiredLength = 2) {
  const numberString = number.toString();
  const padLength = desiredLength - numberString.length;

  if (padLength) {
    return Array(padLength).fill(0).join('') + numberString;
  }

  return numberString;
};

export {
  leftPad
};



// WEBPACK FOOTER //
// ./src/utils/string.js